import invert from 'lodash/invert';

const VARIABLES = {
  first_name: 'PASTOR_FNAME',
  last_name: 'PASTOR_LNAME',
  email: 'PASTOR_EMAIL',
  position_at_church: 'PASTOR_POSITION',
  salutation: 'SALUTATION',
  first_name_2: 'PASTOR_FNAME_2',
  last_name_2: 'PASTOR_LNAME_2',
  email_2: 'PASTOR_EMAIL_2',
  position_at_church_2: 'PASTOR_POSITION_2',
  salutation_2: 'SALUTATION2',
  church_name: 'CHURCH_NAME',
  church_phone: 'CHURCH_NUMBER',
  coffee_with_pastors: 'COFFEE_DETAILS',
  service_times: 'SERVICE_TIME',
  service_address: 'SERVICE_ADDRESS',
  nursery_details: 'NURSERY',
  sunday_school_details: 'SUNDAY_SCHOOL',
  outfit_details: 'WEAR_DETAILS',
  guest_services: 'GUEST_SERVICES',
  church_website_url: 'WEBSITE',
  facebook_page_url: 'FACEBOOK',
  giving_url: 'GIVING',
};

const INVERTED = invert(VARIABLES);

export const fromValuesToKickstartVariables = (values = {}, type) => {
  const out = {};
  Object.keys(values).forEach((key) => {
    let variable = VARIABLES[key];
    const value = values[key];
    if (variable) {
      if (type) {
        variable = `${type}_${variable}`;
      }
      out[`{${variable}}`] = value;
    } else {
      out[key] = value;
    }
  });
  return out;
};

export const kickstartValuesToFormValues = (values = {}) => {
  const out = {};
  Object.keys(values).forEach((key) => {
    const variable = INVERTED[key.replace(/[{}]/gi, '').replace(/easter_/, '')];
    const value = values[key];
    if (variable) {
      out[variable] = value;
    } else {
      out[key] = value;
    }
  });
  return out;
};
